import React from 'react';
import { useTranslation } from 'react-i18next';

import './style.scss';

export interface EditPostProps {
  onClick: () => void;
}

const EditComment: React.FC<EditPostProps> = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <div className="EditPost">
      <button
        type="button"
        className="icon-before icon-writing"
        onClick={onClick}
      >
        {t('common:pages.forum.edit_post.button')}
      </button>
    </div>
  );
};

export default EditComment;
